<template>
	<div id="subsidiaryLedger" >

		<div class="public-content " ref='mr300Css' id="subsidiaryLedger_c">
			<!-- 公共form表单样式 -->
			<div class="form-item-public clearfix">
				<el-form inline label-position="left">
					<el-form-item label="明细账">
						<accounting-period @defaultTime='defaultTime'></accounting-period>
					</el-form-item>
					<el-form-item label="科目名称">
						<el-select
							size="mini"
							placeholder="请选择"
							@change='haandleChange'
							v-model="form.subjectId" filterable clearable>
						    <el-option
						    	v-for="item in subjectData"
						    	:key="item.id"
						    	:label="item.code + '  ' + item.name"
						    	:value="item.id">
						    </el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="辅助类别">
						<el-select
							size="mini"
							placeholder="请选择"
							style='width: 120px;'
							@change='getAuxiliaryAccountingDetail'
							v-model="auxId" filterable clearable>
						    <el-option
						    	v-for="item in auxiliaryAccountingList"
						    	:key="item.id"
						    	:label="item.name"
						    	:value="item.id">
						    </el-option>
						</el-select>
					</el-form-item>

					<el-form-item class="fr">
						<div class='fr'>
							<el-button v-for='item in buttonList' :key='item.id' size='small'
							style='margin: 5px 0px 0 20px' @click='handleButtonClick(item.name)'>
								{{item.name}}
							</el-button>
						</div>
						<el-checkbox  @change="handleCheck"  v-model='isChildrenShow' class="checkBox">显示数量</el-checkbox>
					</el-form-item>

				</el-form>
			</div>
			<el-row class='tableContainer'>
				<el-col :span='19' style='height: 100%;' class='getTableHeight'>
					<public-table  :table="tableData" v-if='refresh'>
						<template slot-scope="props" slot="number">
							<a href="javascript:;" v-text="props.scope.row.number" @click="handleModify(props.scope.row)"></a>
						</template>
					</public-table>
				</el-col>
				<el-col :span='5' style='text-align: right;height: 100%;'>
					<subject-tree :auxiliaryData = 'auxiliaryData' @calbackId='getCalbackId'>
					</subject-tree>
				</el-col>

			</el-row>


			<!-- 修改凭证  -->
			<edit-voucher :visible.sync="XG_voucherShow" :row="rows" @on-close-dialog="cancel" v-if="XG_voucherShow"
				:openButton_s = 'openButton_s'
			></edit-voucher>

		</div>
		<!-- 连续打印弹框 -->
		<el-dialog
			:title='btnTitle'
			class='default-dialog'
			:visible.sync="isShowPrint"
			:close-on-click-modal="false"
			width='380px'>
			<el-form >
				<el-form-item label="范围选择：">
					<el-radio-group v-model="dy_form.type">
				    	<el-radio label="0">当前</el-radio>
				    	<el-radio label="1">全部</el-radio>
				    </el-radio-group>
				</el-form-item>
        <el-form-item label="账簿封面：" v-show="btnTitle == '打印'">
          <el-radio-group v-model="dy_form.isCover">
            <el-radio :label="true">
              <span style="position:relative;">
                <span>打印</span>
                <img src="../../../static/img/default_img.png" alt="" style="width: 14px;position: absolute;left: 32px;top: 1px;cursor: pointer;" @click="showCover = true">
              </span>
            </el-radio>
            <el-radio :label="false">不打印</el-radio>
          </el-radio-group>
        </el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
		    	<el-button size="small" class="secondaryButton" @click="isShowPrint = false">取 消</el-button>
			    <el-button size="small" class='minButton' @click="confirm">{{btnTitle}}</el-button>
		  	</span>
		</el-dialog>

    <!-- 查看封面 -->
    <el-dialog :visible.sync="showCover" width="900px" :close-on-click-modal="true" @close="showCover = false" custom-class="coverDialog" append-to-body>
      <img src="../../../static/img/cover2.jpg" alt="" style="width:100%;">
    </el-dialog>
	</div>

</template>

<script>
	import accountingPeriod from '@/components/dialog/accountingPeriod'
	import SubjectTree from '@/components/subject/publicSiderbar'
	import publicTable from '@/components/publicTable'
	import printOperation from '@/components/print'
	import {currencys} from '@/assets/utils/currencyFormat'
	import editVoucher from '@/components/table/editVoucher'
export default {
	data(){
		return {
			btnTitle:"打印",
      showCover:false,
			openButton_s:false,
			isFirstReq:false,  // 第一次请求不请求数据
			auxiliaryData:[],  // 辅助核算明细
			auxId:"",   // 辅助类别ID
			isFirstActive: false,
			subjectType: '',   // 科目类别
			printForm: {        // 打印参数
				data: {
					start: '',
					end: '',
					subjectId: '',
					isTotal: true
				},
				url: '/createPDF/printTotalDetail',
				continuityUrl: '/createPDF/printTotalDetail'
			},
			dy_form: {
				type:"0",
        isCover:false
			},
			superSubjectId:'', // 科目ID
			isShowPrint: false,      // 连续打印弹框
			printParams: {},  // 打印数据
			options: [{
					value: '1',
					label: '一级'
				},{
					value: '2',
					label: '二级'
				},{
					value: '3',
					label: '三级'
				},{
					value: '4',
					label: '四级'
				},{
					value: '5',
					label: '五级'
				}],
			isFormChange: true,		// 初始获取会计期间和科目ID时获取列表数据
			isLoad: false,			// 是否获取列表
			refresh: true,
			isChildrenShow: false,
			handleSpanShow: true,
			isSubjectShow: true,        // 科目列表是否显示
			form: { // 筛选
				subjectId: '',
				start:'' ,
				end: '',
				accId:"",  // 辅助类别
				auxiliaryAccContentId:"",  // 辅助核算id
			},
			tableData: {
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,				// 是否显示加载动画
				hasSelect: false,			// 是否显示多选
				hasOperation: false,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				Maxheight: null,			// Table最大高度
				hasShowPagination: false,	// 是否显示分页
				config: [{
					label: '日期',
					value: 'date',
					show: 'normal'
				},{
					label: '凭证字号',
					value: 'number',
					width: 90,
					show: 'template'
				},{
					label: '摘要',
					value: 'summary',
					show: 'normal',
					width: 100
				},{
					label: '借方',
					value: 'debitMoney',
					show: 'normal',
					name : "changeable",
					showChild : false,
					formatter: this.formatter,
					children:[
						{
							label: '数量',
							value: 'debitAmount',
							show: 'normal'
						},{
							label: '单价',
							value: 'debitUnitPrice',
							show: 'normal'
						},{
							label: '金额',
							value: 'debitMoney',
							show: 'normal'
						}
					]
				},{
					label: '贷方',
					value: 'creditorMoney',
					show: 'normal',
					name : "changeable",
					showChild : false,
					formatter: this.formatter,
					children:[
								{
							label: '数量',
							value: 'creditorAmount',
							show: 'normal'
						},{
							label: '单价',
							value: 'creditorUnitPrice',
							show: 'normal'
						},{
							label: '金额',
							value: 'creditorMoney',
							show: 'normal'
						}
					]
				},{
					label: '方向',
					value: 'creditDirection',
					show: 'normal',
					width: 50,
				},{
					label: '余额',
					value: 'remainingSum',
					show: 'normal',
					name : "changeable",
					formatter: this.formatter,
					showChild : false,
					children:[
								{
							label: '数量',
							value: 'remainingAmount',
							show: 'normal'
						},{
							label: '单价',
							value: 'remainingUnitPrice',
							show: 'normal'
						},{
							label: '金额',
							value: 'remainingSum',
							show: 'normal'
						}
					]
				}],
				data: [],
				page: {
					pageNo: 1,
					pageSize: 20,
					count: 10
				},
				center: {
					textAlign: 'center',
					padding: '6px 0'
				}
			},

			XG_voucherShow: false, //修改凭证modal
			rows:{},				//列表数据
			buttonList:[],      // 按钮列表
			auxiliaryAccountingList:[],  // 辅助核算类别
			subjectData:[],
		}
	},
	components:{
		accountingPeriod,
		SubjectTree,
		publicTable,
		printOperation,
		editVoucher
	},
	created(){
		//this.getAllSubject();
		this.getButtonAuthorize();
		this.findAllOject();
	},
	mounted(){
		let tableHeight = document.querySelector('.getTableHeight').clientHeight;
		this.tableData.Maxheight = tableHeight?tableHeight:"500px";
		window.onresize=()=>{
			let tableHeight = document.querySelector('.getTableHeight').clientHeight;
			this.tableData.Maxheight = tableHeight?tableHeight:"500px";
		}
	},
	activated() {
		if(this.$route.query.auxId) {
			this.form.subjectId = this.$route.query.subjectId;
			this.auxId = this.$route.query.auxId;
			this.getAuxiliaryAccountingDetail(this.auxId,true);
			//this.getTableList();
		}else {
			if(this.getClickCache&&this.isFirstActive) {
				//this.getAllSubject();
				this.getTableList();
			}
			this.isFirstActive = true;
		}

	},
	computed : {
		getClickCache() {
			return this.$store.state.loadstatus.isClickCache;
		},
		//获取tableData.config名字为changeable的数据
		getTableDatas(){
			let getTableDatas = this.tableData.config.filter((item)=>{
				if(item.name == "changeable"){
					this.tableData.data.forEach((item)=>{
						if(item.debitMoney && item.debitAmount){
							item.debitUnitPrice = (Number(item.debitMoney)/Number(item.debitAmount)).toFixed(2);
						}
						if(item.creditorMoney && item.creditorAmount){
							item.creditorUnitPrice = (Number(item.creditorMoney)/Number(item.creditorAmount)).toFixed(2);
						}
						if(item.remainingSum && item.remainingAmount){
							item.remainingUnitPrice = (Number(item.remainingSum)/Number(item.remainingAmount)).toFixed(2);
						}
					})
					return item;
				}
			})
			return getTableDatas;
		},
		// 科目
		// subjectData() {
		// 	return this.$store.state.getSubjectId.AllSubjectList
		// }
	},
	methods:{
		// 点击按钮
		handleButtonClick(i) {
			this.btnTitle = i;
			this.isShowPrint = true;
		},
		// 获取打印导出导入按钮权限
	      getButtonAuthorize() {
	        const _ = this;
	        let params={
	          permissions:'ac:auxiliary:dayingss,ac:auxiliary:daochuss'
	        }
	         _.$http.post('sys/menu/findPermissionMenu',params).then(res=>{
	            if(res && res.data.code == 1) {
	              _.buttonList = res.data.data;
	            }
	         })
	      },
		// 科目切换
		haandleChange(val) {
			this.form.subjectId = val;
			this.getTableList();
			this.getAuxiliaryAccountingDetail(this.auxId,true);

		},
		// 辅助核算点击返回ID
		getCalbackId(data) {
			this.form.auxiliaryAccContentId = data;
			this.getTableList();
		},
		//查询辅助类别
		findAllOject(){
			const _=this;
			let datas = {
			}
			_.$http.post('auxiliaryAccounting/allAccounting',datas).then((res)=>{
				if(res && res.data.code == '1'){
					_.auxiliaryAccountingList = res.data.data;
					_.auxId = _.auxiliaryAccountingList.length?_.auxiliaryAccountingList[0].id:"";
					_.auxiliaryAccountingList.length&&_.getAuxiliaryAccountingDetail(_.auxiliaryAccountingList[0].id,true);
				}
			})
		},

		// 根据辅助类别查询辅助核算
		getAuxiliaryAccountingDetail(id,type) {
			if(!id) {
				this.auxiliaryData = [];
				this.form.auxiliaryAccContentId = "";
				this.getTableList();
				return;
			}
			const _=this;
			let datas = {
				auxId:id,
				start:this.form.start,
				end:this.form.end
			}
			_.$http.post('subjectAuxiliary/findAuxiliaryHappenData',datas).then((res)=>{
				if(res && res.data.code == '1'){
					this.subjectData = res.data.data.subjectAuxiliary;
					//this.form.subjectId = this.subjectData.length&&this.subjectData[0].id;
					this.auxiliaryData = res.data.data.auxiliaryAccContent;
					if(!this.auxiliaryData.length) {
						this.form.auxiliaryAccContentId = "";
					}else {
						this.form.auxiliaryAccContentId = this.auxiliaryData[0].id;
					}
					if(!this.auxiliaryData.length&&!type) {
						//this.tableData.data = [];

						this.getTableList();
					}
				}
			})
		},
		init(){
			//快速访问

		},
		// 导出功能
	      handleExport() {
	          let params = {
				type:Number(this.dy_form.type),
				isShow:this.isChildrenShow?1:0,
				...this.form
			}
	          const router =this.$router.resolve({
	          path: "/subjectAuxiliary/ExportAuxiliaryDetailedAccounts",
	          query: params
	        })

	        window.location.href = this.$rootUrl + router.href;
	      },
		 // 按钮点击处理
	     handleButtonPrint(type) {
	     	switch(type) {
	     		case 'print_single':
	     			this.printTotalDetail('1');
	     			break;
	     		case 'print_double':
	     			this.openPrintDialog();
	     			break;
	     		default:
	     			return;
	     			break;
	     	}
	     },
	     // 打印&&导出
		confirm() {
			this.isShowPrint = false;
			this.form.accId = this.auxId;
			if(this.btnTitle == "导出") {
				this.handleExport();
			}else if(this.btnTitle == "打印"){
				this.printTotalDetail();
			}
		},

		printTotalDetail () {

			let params = {
				type:Number(this.dy_form.type),
				isShow:this.isChildrenShow?1:0,
        isCover:this.dy_form.isCover,
				...this.form
			}
			const router = this.$router.resolve({
				path: "/subjectAuxiliary/PrintAuxiliaryDetailedAccounts",
				query: params
			})
			window.open(this.$rootUrl + router.href, '_blank')
		},
		// 表格格式化
		formatter(row, column, cellValue, index) {
			switch (column.property) {
				case 'debitMoney':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);
					}
					break;
				case 'creditorMoney':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);
					}
					break;
				case 'remainingSum':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);

					}
					break;
			}
		},
		// 获取科目类别
		getSubjectType(data) {
			let lsDate = JSON.parse(JSON.stringify(data));
			lsDate.unshift("全部");
			this.subjectType = lsDate;
		},
		// 科目树发过来的数据
		onHandleSubjectIdChange(data) {
			if(data.id) {
				this.form.subjectId = data.id;
				this.printForm.subjectId = data.id;
				this.getTableList();
			}
		},
		// 查询所有科目
		// getAllSubject () {
		// 		this.$store.dispatch('getAllSubject')
		// 		if(this.subjectData) {
		// 			this.form.subjectId = this.subjectData[0].id;
		// 		}
		// },
		// 接收会计期间数据
		defaultTime(data) {
			this.form = Object.assign(this.form,{
				start: this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
				end: this.$util.formatDate.format(data.yearPeriodsEnd , 'yyyyMM'),
			})
			if(this.isFirstReq) {
				this.getTableList();
				this.getAuxiliaryAccountingDetail(this.auxId,true);
			}else {

				this.isFirstReq = true;
			}

		},
		// 是否加载Table列表
		isLoadTableList (val) {
			for (const i in val) {
				this.$set(this.printForm.data, i, val[i]);
				if(!val[i]) {
					this.isLoad = false;
					break;
				} else {
					this.isLoad = true;
				}
			}
			//(this.isFormChange && this.isLoad) && this.getTableList();
		},
		// 获取表格数据
		getTableList(){
			try{
				this.tableData.loading=true;
				this.form.accId = this.auxId;
				this.$http.post('subjectAuxiliary/auxiliaryDetailedAccounts',this.form).then(res=>{
					this.isFormChange = false;
					this.tableData.data = res.data.data.map(item => {
						for (const i in item) {
							if (typeof item[i] === 'number') {
								item[i] = item[i] === 0 ? '' : item[i];
							}
						}
						if(item.debitMoney && item.debitAmount){
							item.debitUnitPrice = (Number(item.debitMoney)/Number(item.debitAmount)).toFixed(2);
						}
						if(item.creditorMoney && item.creditorAmount){
							item.creditorUnitPrice = (Number(item.creditorMoney)/Number(item.creditorAmount)).toFixed(2);
						}
						if(item.remainingSum && item.remainingAmount){
							item.remainingUnitPrice = (Number(item.remainingSum)/Number(item.remainingAmount)).toFixed(2);
						}
						return item;
					})
					this.tableData.loading=false;
				})
			}catch(e){
				this.tableData.loading=false;
			}
		},
		// checkbox点击事件
		handleCheck(){
			this.getTableDatas.forEach((item)=>{
				item.showChild = this.isChildrenShow;
			})
			if(!this.isChildrenShow){
				this.refresh = false;
				this.$nextTick(()=>{
					this.refresh = true;
				})
			}
		},
		// handleSubjectShow() {
		// 	this.isSubjectShow = !this.isSubjectShow;
		// 	if(!this.isSubjectShow) {
		// 		this.$refs.mr300Css.style.marginRight = '0px';
		// 		this.$refs.mr300Css.style.transition = 'margin-right .2s';
		// 		this.handleSpanShow = false;
		// 	}else {
		// 		this.$refs.mr300Css.style.marginRight = '300px';
		// 		this.handleSpanShow = true;

		// 	}
		// },




		///凭证列表修改开始打啊大 ---------------------------------------------------
		// 列表修改操作
		handleModify(row){
			const _=this;
			this.openButton_s = true;
			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			_.XG_voucherShow = true;
			_.rows = row;
		},
		cancel(val){
			this.openButton_s = false;
			this.XG_voucherShow = val;
			this.getTableList();
		},
		successEdit(val){//修改成功后的回调
			if(val){
				this.getTableList();
			}
		},
		///凭证列表修改结束 ---------------------------------------------------
	},
	watch: {
		// subjectData(val , oldVal){
		// 	if(this.$route.query.subjectId) {
		// 		return;
		// 	}else {
		// 		this.form.subjectId = val[0].id;
		// 	}
		// },
		'form.subjectId': {
			deep: true,
			handler (val, newVal) {
				if (val) {
					this.isLoadTableList(this.form);
				}
			}
		}
	}
}
</script>

<style lang="less" scoped>
	#subsidiaryLedger{
		height:calc(100% - 60px);
		#subsidiaryLedger_c {
			height:100%;
		}
		.tableContainer {
			height:calc(100% - 57px);
		}
		/*.slide-fade-enter-active {
		  transition: all .1s ease;
		}
		.slide-fade-leave-active {
		  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
		}
		.slide-fade-enter, .slide-fade-leave-to
			{
		  transform: translateX(20px);
		  opacity: 0;
		}*/
		.el-tabs__item {
			padding: 0 15px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/accountBook/auxiliaryDetailed.vue